import React, { useState } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { isNull } from 'lodash';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';
import { TABLE_PAGE_SIZE_OPTIONS } from 'common/constants';
import CustomColumns from 'common/modules/customColumns';
import { getOrderedColumns, getHiddenColumns } from 'common/utils/helpers';

import { COLUMNS_CONFIG } from '../constants';

import ProductColumns from './ProductColumns';

const ListItems = ({
    filterData,
    handleClickBulkItems,
    handleSaveRow,
    isFetching,
    items,
    paginationData,
    rowCount,
    selectionModel,
    setFilterData,
    setSelectionModel,
    tableSettings,
}) => {
    const [rowModesModel, setRowModesModel] = useState({});
    const [selectedRowId, setSelectedRowId] = useState(null);

    const pageSizeOptions = TABLE_PAGE_SIZE_OPTIONS;

    const columns = ProductColumns({
        filterData,
        handleClickBulkItems,
        hiddenColumns: getHiddenColumns(tableSettings),
        orders: getOrderedColumns(tableSettings),
        rowModesModel,
        selectedRowId,
        setRowModesModel,
        setSelectedRowId,
    });
    const getRowHeight = () => 'auto';
    const columnVisibilityModel = columns.reduce(
        (acc, column) => ({ ...acc, [column.field]: !column.hide }),
        {},
    );
    const initialState = {
        pagination: { paginationModel: { pageSize: pageSizeOptions[0] } },
    };
    const onPaginationModelChange = (model) =>
        setFilterData((prev) => ({ ...prev, ...model }));
    const onRowEditStart = (params, event) => {
        const id = params.row.id;
        if (isNull(selectedRowId)) setSelectedRowId(id);
        else event.defaultMuiPrevented = true;
        return false;
    };
    const onRowEditStop = (params, event) => {
        event.defaultMuiPrevented = true;
    };
    const onRowModesModelChange = (model) => setRowModesModel(model);
    const onRowSelectionModelChange = (model) => setSelectionModel(model);
    const onSortModelChange = (model) => {
        if (!model[0]) return;
        setFilterData((prev) => ({
            ...prev,
            orderBy: model[0].field.toLocaleLowerCase(),
            sortBy: model[0].sort,
        }));
    };
    const paginationModel = {
        page: paginationData?.current_page - 1 || 0,
        pageSize: filterData?.pageSize || pageSizeOptions[0],
    };
    const processRowUpdate = (newRow) => {
        handleSaveRow(newRow);
        return newRow;
    };
    const slots = { pagination: CustomPagination };
    const slotProps = {
        pagination: {
            customContent: (
                <CustomColumns.Container
                    columnsConfig={COLUMNS_CONFIG}
                    tableKey="projects"
                />
            ),
            pageSizeOptions,
        },
    };

    return (
        <DataGrid
            checkboxSelection={true}
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            disableColumnMenu
            disableRowSelectionOnClick
            editMode="row"
            experimentalFeatures={{ newEditingApi: true }}
            getRowHeight={getRowHeight}
            hideFooterSelectedRowCount
            initialState={initialState}
            loading={isFetching}
            onPaginationModelChange={onPaginationModelChange}
            onRowEditStart={onRowEditStart}
            onRowEditStop={onRowEditStop}
            onRowModesModelChange={onRowModesModelChange}
            onRowSelectionModelChange={onRowSelectionModelChange}
            onSortModelChange={onSortModelChange}
            pagination
            paginationMode="server"
            paginationModel={paginationModel}
            processRowUpdate={processRowUpdate}
            rowCount={rowCount}
            rowModesModel={rowModesModel}
            rows={items}
            rowSelectionModel={selectionModel}
            slotProps={slotProps}
            slots={slots}
            sortingMode="server"
        />
    );
};

ListItems.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    paginationData: PropTypes.object,
    rowCount: PropTypes.number,
    selectionModel: PropTypes.array,
    setFilterData: PropTypes.func,
    setSelectionModel: PropTypes.func,
    tableSettings: PropTypes.array,
};

export default ListItems;
